import styled from "styled-components";
import {CGP_GAME_OPEN} from "../../../themes/css-global-classes";

export const GamesGridContainerBox = styled.div`
  .${CGP_GAME_OPEN} & {
        display: none;
    }
`;